import React, { Fragment, useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import '../css/banner.css';

function Banner() {

  useEffect(() => {
    const banner = document.querySelector('.banner-conatiner');

    const getLuminance = (rgb) => {
      const [r, g, b] = rgb.match(/\d+/g).map(Number);
      return 0.2126 * r + 0.7152 * g + 0.0722 * b; // Fórmula de luminancia
    };

    const checkBackground = () => {
      const backgroundColor = window.getComputedStyle(banner).backgroundColor;
      const luminance = getLuminance(backgroundColor);

      // Si el fondo es oscuro (luminancia < 128), el texto será blanco
      if (luminance < 128) {
        banner.classList.add('morado');
      } else {
        banner.classList.remove('morado');
      }
    };

    const interval = setInterval(checkBackground, 300); // Verificar cada 0.3 segundos

    return () => clearInterval(interval);
  }, []);

  const fullText = "Revolucionando con Innovación Tecnológica";
  const [displayedText, setDisplayedText] = useState("");
  const speed = 105;
  const deleteSpeed = 40;

  useEffect(() => {
    let i = 0;
    let interval;

    const startTyping = () => {
      interval = setInterval(() => {
        if (i < fullText.length) {
          setDisplayedText(fullText.slice(0, i + 1));
          i++;
        } else {
          clearInterval(interval);
          setTimeout(startDeleting, 1200);
        }
      }, speed);
    };

    const startDeleting = () => {
      interval = setInterval(() => {
        if (i >= 0) {
          setDisplayedText(fullText.slice(0, i));
          i--;
        } else {
          clearInterval(interval);
          setTimeout(startTyping, 500);
        }
      }, deleteSpeed);
    };

    startTyping();

    return () => clearInterval(interval);
  }, []);

  const renderWithHighlight = () => {
    const words = displayedText.split(' ');
    return words.map((word, index) => {
      const isLastWord = index === words.length - 1;
      return (
        <span key={index} className={isLastWord ? 'highlight-subtitle' : ''}>
          {word}{index !== words.length - 1 && ' '}
        </span>
      );
    });
  };

  const scrollToPrices = () => {
    const section = document.querySelector('.section-prices');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Fragment>
      <div className='banner-conatiner'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-6 span-btn-section'>
              <motion.h1
                className='text-banner'
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                {renderWithHighlight()}
              </motion.h1>

              <h4 className='text-sub-banner'>Soluciones inteligentes para empresas</h4>
              <div className='container-btn-banner'>
                <div>
                  <a href="https://calendly.com/agenciajgtc" target="_blank" rel="noopener noreferrer">
                    <button className='btn-pri-banner'>Reunión Ahora</button>
                  </a>
                  <button className='btn-scd-banner' onClick={scrollToPrices}>
                    Ver precios
                  </button>
                </div>
              </div>
            </div>

            <div className='col-md-6'>
              <img className='img-banner' src={require('../img/portada.png')} alt="futuro" />
            </div>

          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default Banner;
